<template>
    <div class="tab-pane fade show active" id="inventory" role="tabpanel" aria-labelledby="inventory-tab">
        <transition name="vue-table-loader">
	        <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-6 clearfix">
                    <h3 class="pt-2 mb-2">Inventory</h3>
                    <p class="text-muted mb-2 text-xs max-w-para">
						This view displays all of the available inventory information data associated with a
                        specific SKU. To learn more about how Jasper PIM handles inventory
                        <a href="https://jasperstudioshelp.zendesk.com/hc/en-us/articles/360026516434-Understanding-Inventory">click here</a>.
					</p>
                </div>
                <div class="col-md-6 text-right" v-if="$parent.permissionAllowed('manage_inventory')">
                    <button class="btn btn-primary text-right ml-1" data-toggle="collapse" data-target="#adjust_inventory">Update Inventory</button>
                </div>
            </div>
            <div id="adjust_inventory" class="collapse border p-4 mb-3">
                <input-loader :fields="productInventory.items.groupItems"></input-loader>
                <div class="form-group row">
                    <div class="col-md-12 text-right">
                        <button type="submit" class="btn btn-primary" @click="saveInventoryData()">Update</button>
                        <button type="button" class="btn btn-secondary" data-toggle="collapse" data-target="#adjust_inventory">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="dataTables_wrapper container-fluid dt-bootstrap4">
                <vuetable ref="vuetable"
                    :api-url="grid"
                    :fields="fields"
                    :css="css.table"
                    data-path="inventory"
                    noDataTemplate="No Inventory Found"
                    @vuetable:loaded="onLoaded"
                    pagination-path=""
                >
                </vuetable>
            </div>
            <transition name="vue-table-loader">
                <div class="messaging" v-if="message">{{message}}</div>
            </transition>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host

import axios from 'axios'
import _ from "lodash";
import moment from 'moment-timezone';
import * as Vuetable from 'vuetable-2';
import InputLoader from '../form/form-loader.vue';

export default {
    name: 'product-inventory',
    components:{
        'input-loader': InputLoader,
    },
    data: function() {
        return {
            loading: true,
            uiStates: {
                errorMessage: true,
                showLoading: true
            },
            message: "",
            grid: base_url + '/pimapi/products/' + this.$parent.product.info.id + '/inventory',
            productInventory: {
                items: {
                    groupingName: 'Inventory',
                    groupItems: [
                        {
                            "name": "count_on_hand",
                            "label": "On Hand",
                            "required": true,
                            "type": "text",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        },
                        {
                            "name": "count_on_hold",
                            "label": "On Hold",
                            "required": true,
                            "type": "text",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        },
                        {
                            "name" : "",
                            "label" : "",
                            "required" : false,
                            "type" : "horizontal-rule",
                            "column" : "col-md-12",
                            "value" : "",
                            "options" : []

                        },
                        {
                            "name": "location",
                            "label": "Location",
                            "required": false,
                            "type": "text",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        },
                        {
                            "name": "bin",
                            "label": "Bin",
                            "required": false,
                            "type": "text",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        },
                        {
                            "name": "source",
                            "label": "Source",
                            "required": false,
                            "type": "text",
                            "column": "col-md-6",
                            "value": "",
                            "options": []
                        }
                    ]
                }
            },
            fields: [
                {
                    name: 'count_on_hand',
                    title: 'On Hand',
                },
                {
                    name: 'saleable',
                    title: 'Saleable',
                },
                {
                    name: 'location',
                    title: 'Location',
                },
                {
                    name: 'bin',
                    title: 'Bin',
                },
                {
                    name: 'source',
                    title: 'Source',
                },
                {
                    name: 'count_on_hold',
                    title: 'On Hold',
                },
                {
                    name: 'updated_at',
                    title: 'Updated',
                    callback: 'formatDate',
                },
            ],
            css: {
                table: {
                    tableClass: 'table table-middle table-minimal',
                    ascendingIcon: 'sort-icon-asc',
                    descendingIcon: 'sort-icon-desc',
                    infoClass: '',
                },
            },
        }
    },
    mounted() {

    },
    methods: {
        formatDate (value) {
            if (value === null) {
                return 'Never';
            }
            if(this.$parent.clientTimezone){
                return moment.utc(value).tz(this.$parent.clientTimezone).format('MMM Do YYYY h:mm a');
            } else {
                return moment(value).format("MMM Do YYYY, h:mm a");
            }
        },
        onLoaded: function() {
            this.loading = false;
        },
        saveInventoryData: function() {
            axios.put(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/inventory', {
                'productInventory' : this.productInventory
            })
            .then(function(response) {
                this.collapseForm();
                this.$refs.vuetable.reload();
                this.clearForm();
                this.$parent.alert.status = "alert-success";
                this.$parent.alert.message = 'Inventory has been updated'
            }.bind(this))
            .catch(function(error) {
                console.log(error);
                this.$parent.alert.status = "alert-danger";
                this.$parent.alert.message = error.response.data.message;
            }.bind(this));


        },
        clearForm: function(){
            if(this.productInventory.items.groupItems.length < 1){
                return;
            }
            this.productInventory.items.groupItems.forEach(element => {
                element.value = "";
            });
        },
        collapseForm: function() {
            $('#adjust_inventory').collapse('toggle');
        }
    },
}
</script>

<style lang="scss" scoped>
    .table-minimal {
        margin-bottom: 0px !important;
    }
    .form-line-break {
        margin-bottom: 35px;
    }
    .messaging{
        color: #566670;
        position: absolute;
        bottom: 2px;
        right: 5px;
        font-size: 9px;
    }
</style>
